import { isInlineEditableType } from 'components/storefront/editor/easyblocks-page/components/inline-editable';
import { getAttributeValue } from './utils';

export const BLOCK_ATTRIBUTE = 'data-editor-block';
export const INLINE_EDITABLE_ATTRIBUTE = 'data-swell-inline-editable';

function hasBlock(blockId, blockElements) {
  return blockElements.some((blockElement) => blockElement.id === blockId);
}

/**
 * @param {object} blockData
 * @param {object[]} inlineEditableConfigs
 */
function processInlineEditable(blockNode, blockData, inlineEditableConfigs) {
  const { path, schema } = blockData;
  const inlineEditableNodes = blockNode.querySelectorAll(
    `[${INLINE_EDITABLE_ATTRIBUTE}]`,
  );

  for (const node of inlineEditableNodes) {
    const fieldId = getAttributeValue(node, INLINE_EDITABLE_ATTRIBUTE);
    const field = schema?.fields?.find((field) => field.id === fieldId);

    if (!field || !isInlineEditableType(field.type)) {
      return;
    }

    inlineEditableConfigs.push({
      container: node,
      content: node.innerHTML,
      type: field.type,
      path,
      fieldId,
    });

    node.innerHTML = '';
  }
}

/**
 * @param {object} blocksData
 * @param {object[]} blockElements
 * @param {object[]} inlineEditableConfigs
 */
function processBlock(blocksData, blockElements, inlineEditableConfigs) {
  return {
    selector: `[${BLOCK_ATTRIBUTE}]`,
    processNode: (node) => {
      const attribute = getAttributeValue(node, BLOCK_ATTRIBUTE);

      try {
        const { id } = JSON.parse(attribute);
        const blockData = blocksData[id];

        if (!blockData || blockData.disabled) {
          return node.remove();
        }

        if (!hasBlock(id, blockElements)) {
          blockElements.push({ id, element: node });
        }

        processInlineEditable(node, blockData, inlineEditableConfigs);
      } catch {
        // noop
      }
    },
  };
}

export default processBlock;
